// CommercialInsuranceFeatureAlt.tsx
import React from 'react';
import { Grid, Box, Typography, Chip, Button, Stack, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import commercialInsuranceImg from "../../../public/main/Commercial Inssurance Monttreal.png";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";

export default function CommercialInsuranceFeatureAlt() {
    const { t, i18n } = useTranslation();
    const theme = useTheme();

    return (
        <Grid mt={6}>
            <motion.div
                initial={{ y: 20, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        gap: { xs: 2, md: 3 },
                        alignItems: 'center',
                        flexDirection: { xs: 'column', md: 'row' },
                        width: '100%',
                        maxWidth: 1200,           // constrain overall width
                        mx: 'auto',               // center container
                        borderRadius: 3,
                        p: { xs: 2, sm: 3, md: 4 },// responsive padding
                        background: 'linear-gradient(180deg, #ffffff 0%, #f6fbff 100%)',
                        border: '1px solid',
                        borderColor: '#e6f0ff',
                        boxShadow: 1,
                        boxSizing: 'border-box',
                        overflow: 'hidden',
                        minWidth: 0,
                    }}
                >
                    {/* Left column (image) */}
                    <Box
                        sx={{
                            flexBasis: { xs: 'auto', md: '44%' },
                            flexShrink: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: { xs: 0, md: 2 },
                            minWidth: 0,
                            width: { xs: '100%', md: 'auto' },
                        }}
                    >
                        <Box
                            component="img"
                            src={commercialInsuranceImg}
                            alt={t('commercialInsuranceAlt.imgAlt')}
                            sx={{
                                width: { xs: '90%', sm: '70%', md: '100%' },
                                maxWidth: 420,
                                height: 'auto',
                                display: 'block',
                                maxHeight: 320,
                                objectFit: 'cover',
                                borderRadius: 2,
                                border: '6px solid',
                                borderColor: '#f0f7ff',
                                boxShadow: 3,
                            }}
                        />
                    </Box>

                    {/* Right column (text content) */}
                    <Box
                        sx={{
                            flex: 1,                    // grow to fill remaining space
                            minWidth: 0,                // IMPORTANT so text can wrap
                            boxSizing: 'border-box',
                            pl: { md: 2 },
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: { xs: 18, sm: 20, md: 22 },
                                fontWeight: 700,
                                color: '#153e75',
                                wordBreak: 'break-word',
                                overflowWrap: 'anywhere',
                                whiteSpace: 'normal',
                                mb: 0.5,
                            }}
                        >
                            {t('commercialInsuranceAlt.header')}
                        </Typography>

                        <Typography sx={{ fontSize: { xs: 13, md: 14 }, color: '#496985', mt: 0.5 }}>
                            {t('commercialInsuranceAlt.subHeader')}
                        </Typography>

                        <Typography sx={{ fontSize: { xs: 12, md: 13 }, color: '#7a9bb3', mt: 1 }}>
                            {t('commercialInsuranceAlt.priceNote')}
                        </Typography>

                        <Stack direction="column" spacing={1} sx={{ mt: 2, mb: 1 }}>
                            {[1, 2, 3].map((n) => (
                                <Chip
                                    key={n}
                                    label={`${n}. ${t(`commercialInsuranceAlt.feature${n}`)}`}
                                    sx={{
                                        m: 0,
                                        fontWeight: 600,
                                        backgroundColor: '#fff',
                                        border: '1px solid #e6f0ff',
                                        boxShadow: 1,
                                        color: '#274c6b',
                                        '& .MuiChip-label': { px: 1.5, fontSize: { xs: 12, md: 13 } },
                                        width: '100%',
                                        textAlign: 'left',
                                        overflowWrap: 'anywhere',
                                    }}
                                />
                            ))}
                        </Stack>

                        <Typography sx={{ fontSize: { xs: 12, md: 13 }, color: '#6b879a', mt: 1 }}>
                            {`* ${t('commercialInsuranceAlt.Eligibality')}`}
                        </Typography>

                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={3}>
                            <Link to={`/${i18n.language}/contact-us`} style={{ width: '100%', textDecoration: 'none' }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        background: 'linear-gradient(135deg, #3b0764, #9333ea)',
                                        color: '#FFFFFF',
                                        border: 'none',
                                        borderRadius: '10px',
                                        width: '100%',
                                        paddingY: { xs: '10px', md: '12px' },
                                        px: { xs: 2, md: 3 },
                                        fontSize: { xs: '0.9rem', md: '1rem' },
                                        textTransform: 'capitalize',
                                        boxShadow: '0 0 16px rgba(147, 51, 234, 0.4)',
                                        transition: 'all 0.3s ease',
                                        boxSizing: 'border-box',
                                        '&:hover': {
                                            background: 'linear-gradient(135deg, #581c87, #a855f7)',
                                            boxShadow: '0 0 22px rgba(147, 51, 234, 0.6)',
                                        },
                                    }}
                                >
                                    {t('commercialInsuranceAlt.cta_quote')}
                                </Button>
                            </Link>
                        </Stack>
                    </Box>
                </Box>
            </motion.div>
        </Grid>
    );
}
